var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('input', {
    class: _vm.$props.containerClass,
    attrs: {
      "type": "checkbox",
      "id": _vm.id,
      "name": _vm.name,
      "disabled": _vm.$props.isDisabled
    },
    domProps: {
      "checked": _vm.$props.isChecked
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('input', $event.target.checked);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }